// src/modules/app-views/crm/pages/Document/decorators/request.js
// *******************************************************************************
// REQUEST DECORATOR
// *******************************************************************************

import dayjs from 'dayjs';

// Transforms form data before sending to the backend
// ctx = { data, allValues, url, method } — must destructure data from ctx
const crmDocumentDecorateRequest = ctx => {
  const { data } = ctx;
  if (!data) return data;

  const result = { ...data };

  // Convert dayjs dates to ISO strings
  if (result.deadline && dayjs.isDayjs(result.deadline)) {
    result.deadline = result.deadline.toISOString();
  }
  if (result.lastInteraction && dayjs.isDayjs(result.lastInteraction)) {
    result.lastInteraction = result.lastInteraction.toISOString();
  }
  if (result.nextInteraction && dayjs.isDayjs(result.nextInteraction)) {
    result.nextInteraction = result.nextInteraction.toISOString();
  }

  // Trim text fields
  if (result.opportunity) {
    result.opportunity = result.opportunity.trim();
  }
  if (result.requirement) {
    result.requirement = result.requirement.trim();
  }
  if (result.proposal) {
    result.proposal = result.proposal.trim();
  }

  return result;
};

export default crmDocumentDecorateRequest;
